// import axios from 'axios';
import api from '@/api';
import * as types from './mutation-types';

export default {
    fetchBadgeGalleryList({ commit }, category) {
        return api.get(`/BadgeGallery?category=${category}`).then((res) => {
            commit(types.FETCH_BADGELIST, res.data.data);
        });
    },
};